import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import TextBox from 'components/common/text_box'
import {
  normalizeDate,
  shortDateInputMaskParts,
  formatDate,
  getTimeZone,
} from 'client/griffin'
import { endOfDay } from 'shared/helpers/datetime_helpers'

class DateInputBox extends React.Component {
  static propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    timeZone: PropTypes.string.isRequired,
    isMobile: PropTypes.bool,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    active: PropTypes.bool,
    isDisabled: PropTypes.bool,
  }

  static defaultProps = {
    timeZone: getTimeZone(),
    isDisabled: false,
  }

  handleValueEvent = (e, done = false) => {
    const { isMobile, timeZone } = this.props

    if (isMobile) {
      if (e.target.value === '') {
        return ''
      }
      // Mobile provides a date picker so do not need validation
      return new Date(e.target.value)
    }

    const value = e.target.value
    // legal date, convert to date object using griffin
    let dateValue = normalizeDate(value, { timeZone, style: 'yMMdd' })

    if (done) {
      if (!dateValue.errors) {
        return endOfDay(dateValue)
      }
    }

    // illegal date, probably because the user is in the middle of typing,
    // just pass the string as is
    return e.target.value
  }

  handleChange = e => {
    if (this.props.onChange) {
      this.props.onChange(this.handleValueEvent(e))
    }
  }

  handleBlur = e => {
    if (this.props.onBlur) {
      this.props.onBlur(this.handleValueEvent(e, true))
    }
  }

  mask = () => {
    const mask = []
    shortDateInputMaskParts({ style: 'yMMdd' }).forEach(
      datePartObj =>
        datePartObj.type === 'literal'
          ? mask.push(datePartObj.value)
          : mask.push(
              ...{
                year: [/\d/, /\d/, /\d/, /\d/],
                month: [/\d/, /\d/],
                day: [/\d/, /\d/],
              }[datePartObj.type]
            )
    )
    return mask
  }

  render() {
    let { value, isMobile } = this.props
    const datePatternLabel = shortDateInputMaskParts({ style: 'yMMdd' })
      .map(datePartObj => datePartObj.value)
      .join('')
      .toUpperCase()

    // if we're on mobile, use the native input[type=date]
    if (isMobile) {
      if (value) {
        // value could be  string or date based on the devices/browsers.
        // new Date works in creating a new date object for either string or object.
        // String doesn't have getTime, if Date is not enforced it will fail
        const valueDateInstance = new Date(value)
        value = isNaN(valueDateInstance.getTime())
          ? ''
          : valueDateInstance.toISOString().split('T')[0] // This is the format that the browser expects for input[type='date']
      } else {
        value = ''
      }

      return (
        <TextBox
          placeholder={datePatternLabel}
          type="date"
          {...this.props}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          value={value}
        />
      )
    }

    if (value instanceof Date) {
      value = formatDate(value, 'yMMdd')
    }

    return (
      <TextBox
        mask={this.mask.bind(this)}
        placeholder={datePatternLabel}
        {...this.props}
        value={value}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
      />
    )
  }
}

export default connect(state => ({
  isMobile: state.device_info.isMobile,
}))(DateInputBox)
